import { FileExcelOutlined } from '@ant-design/icons';
import { FeatureGuide } from '../types';
import { howItHelps, tips, whatItIs } from './sections';

export const invoiceGuide: FeatureGuide = {
    key: 'invoice',
    title: 'Invoice',
    icon: <FileExcelOutlined />,
    sections: [
        whatItIs(
            'An optional commercial invoice uploaded with the declaration. Its contents are read and used to pre-fill the goods items.'
        ),
        howItHelps(
            'Uploading the invoice removes most of the manual goods entry and keeps values and descriptions consistent with the commercial document.'
        ),
        tips([
            'Use a machine-readable file where possible - scanned images extract less reliably.',
            'Review the pre-filled goods items before submitting the declaration.',
        ]),
    ],
};
